<!-- Lista de pedidos -->
<ng-container>
  <div class="historico">

    <!-- Header -->
    <div class="historico-header">
      <button pButton
              icon="pi pi-arrow-left"
              class="p-button-rounded p-button-text historico-btn-voltar"
              (click)="onVoltar()"
              [attr.aria-label]="texts.historico?.voltar || 'Voltar'">
      </button>
      <h1 class="historico-titulo">{{ texts.historico?.titulo || 'Meus Pedidos' }}</h1>
      <button pButton
              *ngIf="pedidos.length > 0"
              icon="pi pi-trash"
              class="p-button-rounded p-button-text p-button-danger historico-btn-limpar"
              (click)="onLimparHistorico()"
              [attr.aria-label]="texts.historico?.limpar_historico || 'Limpar tudo'">
      </button>
    </div>

    <!-- Lista vazia -->
    <div class="historico-vazio" *ngIf="pedidos.length === 0">
      <i class="pi pi-inbox historico-vazio-icone"></i>
      <p class="historico-vazio-texto">{{ texts.historico?.sem_historico || 'Nenhum pedido no historico' }}</p>
    </div>

    <!-- Cards de pedidos -->
    <div class="historico-lista" *ngIf="pedidos.length > 0">
      <div class="historico-card"
           *ngFor="let pedido of pedidos"
           role="button"
           tabindex="0"
           (click)="selecionarPedido(pedido)"
           (keyup.enter)="selecionarPedido(pedido)"
           (keyup.space)="selecionarPedido(pedido)">
        <div class="historico-card-top">
          <span class="historico-card-id">#{{ pedido.codigoDePedido ? pedido.codigoDePedido : pedido.idCurto }}</span>
          <span class="historico-card-data">{{ formatarData(pedido.data) }}</span>
        </div>
        <div class="historico-card-middle">
          <span class="historico-card-tipo">{{ getLabelTipoPedido(pedido.tipoPedido) }}</span>
          <span class="historico-card-tipo" *ngIf="isMesa(pedido) && pedido.numeroMesa"> {{ pedido.numeroMesa }}</span>
          <span class="historico-card-separator">-</span>
          <span class="historico-card-qtd">{{ getLabelItens(getQuantidadeItens(pedido)) }}</span>
        </div>
        <div class="historico-card-bottom">
          <span class="historico-card-total">{{ formatarPreco(pedido.total) }}</span>
          <i class="pi pi-chevron-right historico-card-seta"></i>
        </div>
      </div>
    </div>

  </div>
</ng-container>

<p-confirmDialog></p-confirmDialog>
